import dayjs from 'dayjs';

export type RelativeDateRange =
  | 'TODAY'
  | 'LAST_24_HOURS'
  | 'LAST_7_DAYS'
  | 'LAST_30_DAYS'
  | 'THIS_WEEK'
  | 'THIS_MONTH'
  | 'THIS_YEAR'
  | 'LAST_WEEK'
  | 'LAST_MONTH'
  | 'LAST_YEAR';

export const DATE_RANGE_PRESETS: Record<RelativeDateRange, () => [Date, Date]> =
  {
    TODAY: () => [
      dayjs().startOf('day').toDate(),
      dayjs().endOf('day').toDate(),
    ],
    LAST_24_HOURS: () => [
      dayjs().subtract(23, 'hours').toDate(),
      dayjs().toDate(),
    ],
    LAST_7_DAYS: () => [
      dayjs().subtract(6, 'days').startOf('day').toDate(),
      dayjs().endOf('day').toDate(),
    ],
    LAST_30_DAYS: () => [
      dayjs().subtract(29, 'days').startOf('day').toDate(),
      dayjs().endOf('day').toDate(),
    ],
    THIS_WEEK: () => [
      dayjs().startOf('week').toDate(),
      dayjs().endOf('day').toDate(),
    ],
    THIS_MONTH: () => [
      dayjs().startOf('month').toDate(),
      dayjs().endOf('day').toDate(),
    ],
    THIS_YEAR: () => [
      dayjs().startOf('year').toDate(),
      dayjs().endOf('day').toDate(),
    ],
    LAST_WEEK: () => [
      dayjs().subtract(1, 'week').startOf('isoWeek').toDate(),
      dayjs().subtract(1, 'week').endOf('isoWeek').toDate(),
    ],
    LAST_MONTH: () => [
      dayjs().subtract(1, 'month').startOf('month').toDate(),
      dayjs().subtract(1, 'month').endOf('month').toDate(),
    ],
    LAST_YEAR: () => [
      dayjs().subtract(1, 'year').startOf('year').toDate(),
      dayjs().subtract(1, 'year').endOf('year').toDate(),
    ],
  };
